import React, { useEffect, useState } from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { ImageConstants } from 'common/ImageConstants';
import { pageDataService } from 'common/utilities';
import { WaitForInitialization } from 'common/WaitForInitialization';
import { i18nInit, useLocalizedStrings } from 'i18n';
import { dashboardPath } from 'Routes';

import ErrorBasePage from './ErrorBasePage';

const Loading = () => <Spinner size={SpinnerSize.large} style={{ flex: 1 }} />;

export const ErrorPage404: React.FunctionComponent = () => {
  const { t } = useLocalizedStrings();

  const [locale, setLocale] = useState(pageDataService.getRequestLocale());

  const fetchLocale = async () => {
    try {
      const response = await fetch('/locale');
      const requestLocale = await response.text();
      i18nInit(requestLocale);
      setLocale(requestLocale);
    } catch {
      setLocale('en');
    }
  };

  const goToDashboard = () => {
    window.location.href = dashboardPath;
  };

  useEffect(() => {
    if (!locale) {
      fetchLocale();
    }
  }, [locale]);

  if (!locale) {
    return <Loading />;
  }

  return (
    <WaitForInitialization fallback={<Loading />}>
      <ErrorBasePage
        headerText={t('Errors.404Error.HeaderFirstLine')}
        detailsMessage={t('Errors.404Error.Details')}
        imageFileName={ImageConstants.ExclamationMark}
        primaryButton={{
          text: t('GoToHome'),
          onClick: goToDashboard,
        }}
      />
    </WaitForInitialization>
  );
};

export default ErrorPage404;
